var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.24975V3.99525C10.4997 3.82078 10.4533 3.6495 10.3655 3.49874C10.2777 3.34798 10.1516 3.2231 10 3.13675L6.5 1.13275C6.34772 1.04576 6.17538 1 6 1C5.82462 1 5.65228 1.04576 5.5 1.13275L2 3.13625C1.6905 3.31375 1.5 3.64125 1.5 3.99525V8.00425C1.5 8.35875 1.6905 8.68575 2 8.86275L5.5 10.8667C5.65228 10.9537 5.82462 10.9995 6 10.9995M6 10.9995C6.17538 10.9995 6.34772 10.9537 6.5 10.8667M6 10.9995V5.99976M6 5.99976L10.365 3.47974M6 5.99976L1.63501 3.47974M8 9.49976H11M9.5 7.99976V10.9998",
    stroke: "#017BFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxPlus);
export default __webpack_public_path__ + "static/media/box-plus.acba0fbb1d0c4c07ed0ac42ed965c5e1.svg";
export { ForwardRef as ReactComponent };